import axios from "axios"


export const GLB_URL_APIS = process.env.REACT_APP_APIS_BACK || 'https://localhost:7443'
//export const GLB_URL_APIS = process.env.REACT_APP_APIS_BACK || 'https://thelabapis.risinguparis.com'

export const GLB_URL_THESCAN = process.env.REACT_APP_THESCAN_URL || 'https://localhost:8000'



export default {
  /* AUTH */
  askForNewPasswordEmail : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/askForNewPasswordEmail", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  checkResetPsswd : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/checkResetPsswd", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  setPsswd: async (vals) => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/setPsswd", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  loginUser : async vals => {
    try {
      let valuesToSend = {
        ...vals,
        type : "RisUpTheLab2025"
      }
      const res = await axios.post(GLB_URL_APIS + "/auth/login", valuesToSend, {
        withCredentials: true,
      })
      if (res.data.message == "signin") {

      } else {

      }
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getLoginStatus: async () => {
    try {
      const res = await axios.get(GLB_URL_APIS + "/auth/status", {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getAllInfos: async (id) => {
    let tmpID = null
    if (id) {
      tmpID = id
    }
    try {
      const res = await axios.post(GLB_URL_APIS + "/formation/getAllInfos", {id : tmpID}, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },
  /* END AUTH */

  /* CLIENT DASHBOARD */
  completionAndSoftSkills : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/clientAdmin/completionAndSoftSkills", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  clientAdminSuivi : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/clientAdmin/suivi", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  clientAdminMapping : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/clientAdmin/mapping", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },
  /* END CLIENT DASHBOARD */

  /* ACCOUNT */
  updateAccount : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/updateAccount", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },
  updatePassword : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/updatePassword", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  onBoard : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/onBoardingAll", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  checkGroupCode : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/checkCode", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  register : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/register", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  checkAdminRegister : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/checkAdminRegister", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  adminRegister : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/adminRegister", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },
  /* END ACCOUNT */

  /* FORMATION */
  editFormationResult : async (elementID, type, vals) => {
    let values = {
      elementID : elementID,
      vals : vals
    }
    try {
      const res = await axios.post(GLB_URL_APIS + "/formation/"+type+"/saveResult", values, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getCertifInfos : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/formation/getCertifInfos", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },
  /* END FORMATION */

  /* SUPER ADMIN */
  getSuperAdminGroupes : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getSuperAdminContents : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getSuperAdminAdminClients : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/admin/adminclient", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getSuperAdminEcoles : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/ecoles/admin", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getMailingTemplates : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/templates", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getMailingByGroupAndContent : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addMailing : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/add", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  editMailing : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/edit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  editMailingPlan : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/planEdit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  removeMailing : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/remove", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  forceSendingMailing : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/forceSending", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  testSendingMailing : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/testSending", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addMailingTemplate : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/templates/add", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  removeMailingTemplate : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/mailing/templates/remove", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  archiveOrNotGroupe : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/archiveOrNot", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  resetGroupLogo : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/resetLogo", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addGroupe : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/add", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  editGroupe : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/edit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getGroupeUsers : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/users", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  createSimuForGroupe : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/createSimu", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  saveGroupeCertification : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/saveCertification", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getGroupeUsersResults : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/groupe/admin/usersResults", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getContentByIdForAdmin : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/getOneById", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addEcole : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/ecoles/admin/add", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  editEcole : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/ecoles/admin/edit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addCampusForEcole : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/ecoles/admin/campus/add", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  deleteCampusForEcole : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/ecoles/admin/campus/delete", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  resendInvitForAdminClient : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/admin/adminclient/resendInvit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addAdminClient : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/admin/adminclient/add", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  editAdminClient : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/user/admin/adminclient/edit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addContent : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/add", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  editContent : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/content/edit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  checkForChangeContentType : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/checkForChangeContentType", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  archiveOrNotContent : async vals => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/archiveOrNot", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  editFormationElement : async (type, vals) => {
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/"+type+"/edit", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  addFormationElement : async (type, idToAdd, vals) => {
    let values = {idToAdd : idToAdd, vals : vals}
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/"+type+"/add", values, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  removeFormationElement : async (type, idToRemove) => {
    let vals = {id : idToRemove}
    try {
      const res = await axios.post(GLB_URL_APIS + "/content/admin/"+type+"/remove", vals, {
        withCredentials: true,
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },
  /* END SUPER ADMIN */
}
